/**
 * Utility functions
 */
export function formatMillisecondsDate (milliseconds) { // milliseconds => 'April 21, 2017 3:30 PM'
  if (milliseconds) {
    const date = new Date(milliseconds)

    return date.toLocaleString('en-US', {
      hour12: true,
      month: 'long',
      year: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    })
  } else {
    return ''
  }
}

export function getReadableFileSizeString (fileSizeInBytes) { // 1554657 => 1.5MB
  if (fileSizeInBytes) {
    let i = -1
    const byteUnits = [' kB', ' MB', ' GB', ' TB']
    do {
      fileSizeInBytes = fileSizeInBytes / 1024
      i++
    } while (fileSizeInBytes > 1024)
    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i]
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/editorUtils.js